import { Component, OnDestroy } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { UserCompany } from './models/user-company.model';
import { ExternService } from './services/extern.service';
import { Extern } from './models/extern.model';
import { AuthService } from './services/auth.service';
import { CssThemeService } from './services/css-theme.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CompanyContextService } from './services/company-context.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnDestroy {

  public company: UserCompany | null = null;
  public coop: Extern | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private themeService: NbThemeService,
		protected externService: ExternService,
    protected authService: AuthService,
    private customThemeService: CssThemeService,
    private companyContextService: CompanyContextService
  ) {
    // Charger theme initial au login
    this.authService.authState$.pipe(
      takeUntil(this.destroy$),
      filter(isLoggedIn => isLoggedIn)
    ).subscribe(() => {
      const company = this.companyContextService.getCurrentCompany();
      if (company) {
        this.loadTheme(company);
      }
    });

    // Recharger theme quand on change de company
    this.companyContextService.watchCompanyChanges().pipe(
      takeUntil(this.destroy$)
    ).subscribe(company => {
      this.loadTheme(company);
    });
  }

  ngOnInit(): void {
    this.themeService.onThemeChange().subscribe((theme) => {
      document.documentElement.className = '';
      document.documentElement.classList.add(theme.name);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadTheme(company: UserCompany): void {
    this.company = company;

    if (company.coopId) {
      this.externService.getOne(company.coopId).subscribe(coop => {
        this.coop = coop;
        this.changeThemeBasedOnCoop(this.coop);
      });
    } else {
      this.coop = null;
    }
  }

  private changeThemeBasedOnCoop(coop: any): void {
    let themeName: string;

    // themeName = 'qwintal';
    if (coop.name) {
      themeName = coop.cssTheme;
    } else {
      themeName = 'qwintal';  // Thème par défaut
    }

    if (this.customThemeService.isThemeAvailable(themeName)) {
      this.changeTheme(themeName);
    } else {
      this.changeTheme('qwintal');
    }
  }

  public changeTheme(themeName: string): void {
    this.themeService.changeTheme(themeName);
  }
}
